module.exports = __webpack_public_path__ + "static/media/PxGroteskBold.c4981987.ttf";